import './Header.css';
import CustomDropdown from './CustomDropdown';
import UserMenu from './UserMenu';
import Select from "react-select";

const Header = ({ points, token, userDetails, setShowModal, setSelected, selected, categoryDropdown, selectedOption, setSelectedOption ,setIsPointHistory,setIsPurchase}) => {

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const formatOptions = (data) => {
    return data.map((category) => {
      if (category.SubCategories.length > 0) {
        // Group with subcategories as options
        return {
          label: category.CategoryType,
          options: category.SubCategories.map((sub) => ({
            value: `subcategory-${sub.SubCategoryID}`,
            label: sub.SubCategoryType,
            categoryId: category.CategoryID,
            SubCategoryID: sub.SubCategoryID,
            isSubcategory: true
          }))
        };
      } else {
        return {
          value: `category-${category.CategoryID}`,
          label: category.CategoryType,
          isSubcategory: false,
          categoryId: category.CategoryID,
          SubCategoryID: 0,
        };
      }
    });
  };

  const options = formatOptions(categoryDropdown);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#373333',
      color: 'white',
      borderColor: state.isFocused ? 'white' : 'gray',
      borderRadius: "8px",
      boxShadow: state.isFocused ? '0 0 0 1px white' : 'none',
      '&:hover': {
        borderColor: 'white',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#ccc',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#373333',
      color: 'white',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#444'
        : state.isFocused
          ? '#222'
          : '#373333',
      color: state.isSelected ? "#6366f1" : 'white',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#333',
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'white',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    input: (provided) => ({
      ...provided,
      color: 'white',
    }),
  };


  return (
    <div className="app-header">
      <div className='category-dropdown'>
        <Select
          inputId="react-select"
          options={options}
          value={selectedOption}
          onChange={handleChange}
          placeholder="Select..."
          isClearable
          styles={customStyles}
        />
      </div>
      <div className="header-right">
        <h5 className='m-0 points'>Points : {points}</h5>
        <CustomDropdown selected={selected} setSelected={setSelected} />
        <UserMenu token={token} userDetails={userDetails} setShowModal={setShowModal} setIsPurchase={setIsPurchase} setIsPointHistory={setIsPointHistory}/>
      </div>
    </div>
  );
};

export default Header;
